import { WRAPPER } from '@/shared/styles/themes';
import { styled } from 'styled-components';

export const Wrapper = styled.div<{ isFullscreen: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .game-iframe {
    display: flex;
    width: 100%;
    height: 100%;
    border: none;
  }

  width: 100%;
  height: ${({ $isFullscreen }) =>
    $isFullscreen ? 'calc(100dvh + 1px)' : '100%'};
  min-height: ${({ $isFullscreen }) =>
    $isFullscreen ? 'calc(100dvh + 1px)' : '100%'};
  display: ${({ $isExit }) => $isExit && 'none'};

  @media (min-width: 1024px) {
    height: ${({ $isFullscreen }) =>
      $isFullscreen ? 'calc(100dvh + 1px)' : '100%'};
    min-height: ${({ $isFullscreen }) =>
      $isFullscreen ? 'calc(100dvh + 1px)' : '100%'};
    display: ${({ $isExit }) => $isExit && 'none'};
  }
`;
export const IframePaddingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  @media (orientation: landscape) {
    //@media (max-width: 1024px) and (orientation: landscape) {
    padding: 12px;
  }
  @media (orientation: portrait) {
    //@media (max-width: 1024px) and (orientation: portrait) {
    //  padding: 18px;
    padding: 12px;
  }
`;
export const IframeRoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;

  @media (orientation: landscape) {
    //@media (max-width: 1024px) and (orientation: landscape) {
    border-radius: 8px;
    overflow: hidden;
  }
  @media (orientation: portrait) {
    //@media (max-width: 1024px) and (orientation: portrait) {
    border-radius: 8px;
    overflow: hidden;
  }
`;
